import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';
export default class ComponentToPrint extends React.Component {

  render() {
    const cashCountList = this.props.cashCountList;
    const coinTotal = this.props.coinTotal;
    const remainingValueTotal = this.props.remainingValueTotal;
    const selectedSearchValues = this.props.selectedSearchValues;
    const searchDate = this.props.searchDate;
    const prevTotalAmount = this.props.prevTotalAmount;
    const coinNames = this.props.coinNames;
    const columnTitles = this.props.columnTitles;
    const selectedDate = this.props.selectedDate;

    let monthNames = ["JAN", "FEB", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
    var month = selectedDate.getMonth() - 1;
    let monthName = monthNames[month + 1];

    return (
      <div>
        <div style={{ width: '1093px', height: '1059px', padding: '20px', margin: 'auto'}}>
          <br />
          <h2><center><u>Denomination Report</u></center></h2>
          <div>&nbsp;</div>
          <h3><center>Group : {selectedSearchValues.groupName}</center></h3>
          <h3><center>Factory : {selectedSearchValues.factoryName}</center></h3>
          <h3><center>Route: {selectedSearchValues.routeName == undefined ? 'All Route' : selectedSearchValues.routeName}</center></h3>
          <h3><center>({selectedDate.getFullYear()} - {monthName})</center></h3>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050}>
              <TableContainer>
                <Table aria-label="caption table" size="small">
                  <TableHead>
                    <TableRow>
                      {columnTitles.map((title, index) => (
                        <TableCell key={title} align={index === 0 ? "left" : index === 1 ? "left" : "right"} style={{ border: '1px solid #ccc' }}>{index !== 0 && index !== 1 && index !== 2 && index !== columnTitles.length - 1 ? `Rs. ${title}` : title}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cashCountList.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                        >
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                        >
                          {data.supplierName}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                        >
                          {data.amount.toFixed(2)}
                        </TableCell>
                        {data.cashCount.map((coin, index) => (
                          <TableCell key={coinNames[index]} align='right' component="th" scope="row" style={{ border: '1px solid #ccc' }}
                          >
                            {coin.coinCount}
                          </TableCell>
                        ))}
                        <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                        >
                          {data.remainingValue}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableRow>
                    <TableCell align={'left'} style={{ border: '1px solid #ccc' }}><b>Total</b></TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                    >
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                    >
                      <b>{prevTotalAmount.toFixed(2)}</b>
                    </TableCell>
                    {coinTotal.map((coin, index) => (
                      <TableCell key={coinNames[index]} align='right' component="th" scope="row" style={{ border: '1px solid #ccc' }}
                      >
                        <b>{coin.coinCount}</b>
                      </TableCell>
                    ))}
                    <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                    >
                      <b>{remainingValueTotal}</b>
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
        </div></div>
    );
  }
}
